var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswerCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.790791 1.84862C0.886561 5.4041 2.28721 8.93564 5.0047 11.6531C7.72219 14.3706 11.2537 15.7713 14.8092 15.867C15.0247 15.867 15.2402 15.7832 15.4078 15.6156C15.5754 15.4481 15.6592 15.2326 15.6592 15.0171L15.6592 12.0482C15.6592 11.8327 15.5754 11.6172 15.4078 11.4496C15.2462 11.288 15.0307 11.2042 14.8212 11.1982C13.9054 11.1683 12.9956 11.0007 12.1217 10.7134C11.8284 10.6116 11.4872 10.6775 11.2478 10.9169L9.39219 12.7725C8.23696 12.1918 7.15954 11.4137 6.20183 10.456C5.24413 9.4983 4.46599 8.42088 3.87939 7.27163L5.73495 5.41607C5.96839 5.18263 6.04022 4.83546 5.93846 4.54216C5.64517 3.66227 5.48954 2.75245 5.44764 1.83664C5.44764 1.62116 5.35785 1.41166 5.19624 1.25005C5.02864 1.08245 4.81316 0.99865 4.59767 0.99865L1.62878 0.998649C1.4133 0.998651 1.19782 1.08245 1.03022 1.25005C0.862618 1.41765 0.790791 1.63313 0.790791 1.84862Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerCall);
export default __webpack_public_path__ + "static/media/answer_call.a9d508a7.svg";
export { ForwardRef as ReactComponent };